import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';

import {messageTextValidation, nameValidation, emailValidation, phoneValidation, locationValidation} from '../../../../utils/itemValidation';
import {displayPhoneInput} from '../../../../utils/formatting';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';

class ScheduleServiceForm extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    const firstEntry = [{display: 'Select a Location*', 'value': ''}];
    const finalEntry = [{display: 'Virtual/Other', 'value': 'online@diamondsdirect.com'}];

    let newArray= firstEntry.concat(locations.locations).concat(finalEntry);


		this.state = {

      locations: newArray,

      inputFirstName: '',
      inputLastName: '',
      inputContactPhone: '',
      inputContactEmail: '',
      inputPurchasedBool: '',
      inputPurchasedName: '',
      inputLocation: '',
      inputDescription: '',

      errorFirstName: false,
      errorLastName: false,
      errorContactPhone: false,
      errorContactEmail: false,
      errorPurchasedBool: false,
      errorPurchasedName: false,
      errorLocation: false,
      errorDescription: false,
    }
	}

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  changeFirstName(evt) { 
    this.setState({ inputFirstName: evt.target.value }, () => {
      if(this.state.errorLastName && !nameValidation(this.state.inputFirstName)) {
        this.setState({ errorLastName: null });
      }
    });
  }

  changeLastName(evt) { 
    this.setState({ inputLastName: evt.target.value }, () => {
      if(this.state.errorLastName && !nameValidation(this.state.inputLastName)) {
        this.setState({ errorLastName: null });
      }
    });
  }

  changeContactPhone(evt) { 
    this.setState({ inputContactPhone: displayPhoneInput(evt.target.value) }, () => {
      if(this.state.errorContactPhone && !phoneValidation(this.state.inputContactPhone)) {
        this.setState({ errorContactPhone: null });
      }
    });
  }

  changeContactEmail(evt) { 
    this.setState({ inputContactEmail: evt.target.value }, () => {
      if(this.state.errorContactEmail && !emailValidation(this.state.inputContactEmail)) {
        this.setState({ errorContactEmail: null });
      }
    });
  }

  changePurchasedBool(evt) { 
    this.setState({ inputPurchasedBool: evt.target.value }, () => {
      if(this.state.errorPurchasedBool) {
        this.setState({ errorPurchasedBool: null });
      }
    });
  }

  changePurchasedName(evt) { 
    this.setState({ inputPurchasedName: evt.target.value }, () => {
      if(this.state.errorPurchasedName && !nameValidation(this.state.inputPurchasedName)) {
        this.setState({ errorPurchasedName: null });
      }
    });
  }

  changeLocation(evt) { 
    this.setState({inputLocation: evt.target.value}, () => {
      if(this.state.errorLocation !== null && this.state.inputLocation !== '') {
        this.setState({errorLocation: null});
      }
    });
  }

  changeDescription(evt) { 
    this.setState({ inputDescription: evt.target.value }, () => {
      if(this.state.errorDescription && !messageTextValidation(this.state.inputDescription)) {
        this.setState({ errorDescription: null });
      }
    });
  }

  validateLocation() {

  }

  validateFirstName(evt) {
    this.setState({
      errorFirstName: nameValidation(evt.target.value) !== null,
    });
  }

  validateLastName(evt) {
    this.setState({
      errorLastName: nameValidation(evt.target.value) !== null,
    }); 
  }

  validateEmailInput(evt) {
    console.log(emailValidation(evt.target.value));
    this.setState({
      errorContactEmail: emailValidation(evt.target.value) !== null,
    });
  }

  validatePhoneInput(evt) {
    this.setState({
      errorContactPhone: phoneValidation(evt.target.value) !== null,
    });
  }


  validateAll() {

    let locationError = this.state.inputLocation === '';
    let purchasedError = this.state.inputPurchasedBool === '';
    let firstNameError = nameValidation(this.state.inputFirstName) !== null;
    let lastNameError = nameValidation(this.state.inputLastName) !== null;
    let emailError = emailValidation(this.state.inputContactEmail) !== null;
    let phoneError = phoneValidation(this.state.inputContactPhone) !== null;
    
    this.setState({
      errorFirstName: firstNameError,
      errorLastName: lastNameError,
      errorPurchasedBool: purchasedError,
      errorSalesAssociate: false,
      errorLocation: locationError,
      errorShoppingFor: false,
      errorDetails: false,
      errorContactPhone: phoneError,
      errorContactEmail: emailError,
    });

    return !locationError && !purchasedError && !firstNameError && !lastNameError && !emailError && !phoneError;
  }

  submitContactRequest() {
    if(this.validateAll()) {

      let serviceData = {
        location_email: this.state.inputLocation,
        purchased_bool: this.state.inputPurchasedBool,
        first_name: this.state.inputFirstName,
        last_name: this.state.inputLastName,
        email: this.state.inputContactEmail,
        phone: this.state.inputContactPhone,
        account: this.state.inputPurchasedName,
        message: this.state.inputDescription,
      }

      this.props.commonServiceRequest(serviceData);
      this.props.commonAlert('Thank you for submitting an appointment request! A member of our Customer Care Team will follow up with you shortly to finalize your appointment.', 'Continue Shopping', 'visit', '');
      this.setState({
        inputFirstName: '',
        inputLastName: '',
        inputContactPhone: '',
        inputContactEmail: '',
        inputPurchasedBool: '',
        inputPurchasedName: '',
        inputLocation: '',
        inputDescription: '',

        errorFirstName: false,
        errorLastName: false,
        errorContactPhone: false,
        errorContactEmail: false,
        errorPurchasedBool: false,
        errorPurchasedName: false,
        errorLocation: false,
        errorDescription: false,
      });
    }
  }

	render() {
		return <div className='ScheduleServiceForm'>
      <div className='closeContact' onClick={::this.props.closeMethod}>
        <div className='closeX'>&times;</div>
      </div>
			<div className='formHeader'>Schedule a Service Appointment</div>
      <div className='formBody'>

        <div className='formRow'>
          <div className='oneHalfSection'>
            <RhinoSelect
              selectClass={'scheduleSelect'}
              required={true}
              value={this.state.inputLocation}
              options={this.state.locations}
              changeMethod={(evt) => this.changeLocation(evt)}
              error={this.state.errorLocation} />
          </div>
          <div className='oneHalfSection'>
            <div className={this.state.errorPurchasedBool ? 'radioYesNoLabel error' : 'radioYesNoLabel'}>Was the item purchased from us?&#42;</div>
            <div className='radioInputRow'>
              <div className='radioInputWrapper'>
                <div className='radioInputElement'>
                  <input 
                    className={this.state.errorPurchasedBool ? 'radioInput error' : 'radioInput'}
                    type='radio'
                    name='radioShopPreviously'
                    value={'Yes'}
                    checked={this.state.inputPurchasedBool === 'Yes'}
                    onChange={::this.changePurchasedBool} />
                </div>
                <div className='radioLabel'>Yes</div>
              </div>
              <div className='radioInputWrapper'>
                <div className='radioInputElement'>
                  <input 
                    className={this.state.errorPurchasedBool ? 'radioInput error' : 'radioInput'}
                    type='radio'
                    name='radioShopPreviously'
                    value={'No'}
                    checked={this.state.inputPurchasedBool === 'No'}
                    onChange={::this.changePurchasedBool} />
                </div>
                <div className='radioLabel'>No</div>
              </div>
            </div>
            <div className={this.state.inputPurchasedBool === 'Yes' ? 'expandableHalfSection open' : 'expandableHalfSection'}>
              <input 
                className={this.state.errorPurchasedName ? 'textInput error' : 'textInput'}
                type='text' 
                placeholder='Name on account'
                value={this.state.inputPurchasedName}
                onChange={::this.changePurchasedName} />
            </div>
          </div>
        </div>



        <div className='formRow'>
          
          
        </div>
        <div className='formRow'>
          <div className='formSubheader'>Your Contact Information</div>
          <div className='oneHalfSection'>
            <input 
              className={this.state.errorFirstName ? 'textInput error' : 'textInput'}
              type='text' 
              placeholder='First Name&#42;'
              value={this.state.inputFirstName}
              onChange={::this.changeFirstName}
              onBlur={::this.validateFirstName} />
          </div>
          <div className='oneHalfSection'>
            <input 
              className={this.state.errorLastName ? 'textInput error' : 'textInput'}
              type='text' 
              placeholder='Last Name&#42;'
              value={this.state.inputLastName}
              onChange={::this.changeLastName}
              onBlur={::this.validateLastName} />
          </div>
        </div>
        <div className={'formRow preBanner'}>
          <div className='oneHalfSection'>
            <input 
              className={this.state.errorContactEmail ? 'textInput error' : 'textInput'}
              type='email' 
              placeholder='Email&#42;'
              value={this.state.inputContactEmail}
              onChange={::this.changeContactEmail}
              onBlur={::this.validateEmailInput} />
          </div>
          <div className='oneHalfSection'>
            <input 
              className={this.state.errorContactPhone ? 'textInput error' : 'textInput'}
              type='tel' 
              placeholder='Phone&#42;'
              value={this.state.inputContactPhone}
              onChange={::this.changeContactPhone}
              onBlur={::this.validatePhoneInput} />
          </div>
        </div>
        <div className='formRow'>
          <div className='textareaLabelWrapper'>Description of services needed (ex: sizing, cleaning, loose diamond, rhodium plating, etc&hellip;)&#42;</div>
          <div className='textareaInputWrapper'>
            <textarea
              className={this.state.errorDescription ? 'textTextarea error' : 'textTextarea'}
              placeholder=''
              value={this.state.inputDescription}
              onChange={::this.changeDescription}>
            </textarea>
          </div>
        </div>
        <div className='repairNotice'>Walk-ins always welcome! No appointment needed for routine jewelry cleanings.</div>
        <div className='formRow'>
          <div className={'submitButton actionButton'} onClick={::this.submitContactRequest}>Request an Appointment</div>
        </div>

      </div>
		</div>;
	}
}
export default ScheduleServiceForm;

function mapStateToProps(state) {
  return {

  };
}

export const ScheduleServiceFormContainer = connect(
  mapStateToProps,
  allActionCreators
)(ScheduleServiceForm);


// WEBPACK FOOTER //
// ./src/components/views/scheduleappointment/components/ScheduleServiceForm.jsx